// Extnernal packages
import * as React from 'react';
import { z } from 'zod';

// Components
import { Button } from 'components/Button';
import { Icon } from 'components/Icons';
import { Card } from 'components/Card';

// Modules
import { PlacesList } from 'modules/places/PlacesList';
import { PlaceModal } from 'modules/places/PlaceModal';

// Hooks
import { useCreatePlace } from 'api/place';

// Schemas
import { placeCreateSchema } from 'schemas/place';

export default function PlacesPage() {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { mutate: createPlaceMutation, isPending: isCreatingPlace } =
    useCreatePlace();

  const handleAddPlace = (data: z.infer<typeof placeCreateSchema>) => {
    createPlaceMutation(
      { data },
      {
        onSuccess: () => {
          setModalOpen(false);
        },
      }
    );
  };

  return (
    <Card className="flex flex-col h-full min-h-[calc(100vh-9rem)] md:min-h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between gap-x-8 gap-y-4">
        <h1 className="text-2xl text-gray-600">Sobe</h1>
        <PlaceModal
          onSubmit={handleAddPlace}
          modalTrigger={<Button icon={<Icon name="plus" />}>Dodaj sobu</Button>}
          isOpen={modalOpen}
          onOpenChange={setModalOpen}
          isPending={isCreatingPlace}
        />
      </div>
      <hr className="my-6 h-px text-gray-200" />
      <PlacesList />
    </Card>
  );
}
